import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { SearchResultType } from "../../../type";

type SearchParams = {
  q: string;
  lang: string;
  store: string;
  country: string;
  shop: string;
};

export const searchApi = async (
  requestInstance: ChameleonRequest,
  searchParams: SearchParams,
) => {
  const url = getApiUrl({
    path: "/fashion/customercaresearch/v1/search/",
    searchParams,
  });

  try {
    const response = await requestInstance.get<SearchResultType>(url, {
      method: "GET",
    });

    return response.data;
  } catch (error) {
    console.error("Error performing search:", error);
    return null;
  }
};
